
<v-expansion-panels
    v-model = "expandFilter"
    class   = "pr-2"
    accordion
    flat
>
    <v-expansion-panel class="pa-0">
        <v-expansion-panel-header :ripple="false" expand-icon="" hide-actions class="pa-0" >
            <c-column-header
                label = "Kunden und Anlagen"
                class = "primary"
                style = "font-size: 16px;"
            >
                <template v-slot:filter>
                    <c-item-count :count="count" />
                    <div>
                        <a @click.stop="onFilter">
                            <v-icon size="18" class="pr-1 white--text">mdi-filter</v-icon>
                        </a>

                        <a
                            @click.stop = "onRemoveFilter"
                            v-show      = "filterOn || (search && search.length > 0)"
                        >
                            <v-icon size="18" class="pr-1 white--text ">mdi-filter-off-outline</v-icon>
                        </a>
                    </div>
                </template>
            </c-column-header>
        </v-expansion-panel-header>

        <v-expansion-panel-content
            class="header-content"
            eager
        >
            <m-customer-filter
                @changed     = "onFilter"
                @customer    = "onFilter"
                :text-search = "true"
                :show-misc   = "false"
                ref          = "filter"
            />
        </v-expansion-panel-content>
    </v-expansion-panel>
</v-expansion-panels>
